import {
	Avatar,
	Card,
	Divider,
	message,
	Select,
	Table,
	Tag,
	Tooltip,
} from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import TableHeaderSection from '../../component/TableHeaderSection';
import baseuri from '../../methods/baseuri';
import {
	Country,
	genderEnum,
	statusColor,
} from '../../methods/utils/request-helpers';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getUserProfileById } from '../../methods/redux/reducers/user-profile';
import { MyEmptyTable } from '../../robots/email-robot/EmailRobot';
import { MyTableCard } from '../users-list/UsersByCountry';
import { MyTable } from '../users-list/UsersList';
import ImageComponent from './ImageComponent';
import NextKyc from './NextKyc';
import RejectKYC from './RejectKYC';
import { FakeRef, SearchSection, TableProfile } from './UsersKYC';

const MyCard = styled(Card)`
	border-radius: 10px;

	.profile-badge-icon {
		display: flex;
		justify-content: center;
		position: relative;
		display: inline-block;
		padding: 5px;
		font-size: 12px;
		margin-right: 5px;
		font-weight: 600;

		& .icon {
			position: absolute;
			font-size: 12px;
			font-weight: bold;
			color: white;
			top: -5px;
			right: -5px;
			background: var(--green-color);
			height: 14px;
			width: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
		}
	}

	.sumsub-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
	}

	.verification-item {
		margin-bottom: 12px;
		border-bottom: 1px solid #d4caca;

		& h3 {
			margin-bottom: 4px;
		}
	}
`;
const Level1Section = styled.div`
	min-width: 250px;

	& .sus {
		color: red;
	}
`;

const MainColumn = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	/* justify-content: center; */
	/* align-items: center; */
	gap: 0.5em;
`;

const Levels = styled.div`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	gap: 1em;
	min-width: 200px;
`;

const SusLink = styled.div`
	display: flex;
	gap: 2em;
	min-width: 220px;
	& .sus {
		color: red;
		cursor: pointer;
	}
`;

const KYCDataCard = {
	display: 'flex',
	gap: '1em',
	width: '100%',
};

const ManageKYC = () => {
	const dispatch = useAppDispatch();
	const { id } = useParams<{ id: string }>();
	const [refresh, setRefresh] = useState(0);
	const [data, setData] = useState({} as any);
	const [kycHistory, setKycHistory] = useState({} as any);
	const [selectedGateway, setSelectedGateway] = useState(
		'https://cf-ipfs.com/ipfs/'
	);
	console.info(selectedGateway);
	const { user } = useAppSelector((store) => store.userProfile);

	const gateWays = [
		{ name: 'https://cf-ipfs.com/ipfs/', value: 'https://cf-ipfs.com/ipfs/' },
		{ name: 'https://ipfs.io/ipfs/', value: 'https://ipfs.io/ipfs/' },
		{
			name: 'https://cloudflare-ipfs.com/ipfs/',
			value: 'https://cloudflare-ipfs.com/ipfs/',
		},
		{
			name: 'https://gateway.ipfs.io/ipfs/',
			value: 'https://gateway.ipfs.io/ipfs/',
		},
		{
			name: 'https://gateway.pinata.cloud/ipfs/',
			value: 'https://gateway.pinata.cloud/ipfs/',
		},
	];

	const approve = async (userId: string, url: string) => {
		try {
			const res: any = await baseuri.post(url, {
				id: userId,
				kycStatus: 'approved',
			});

			if (res.status === 200) {
				message.success(`Approved successfully `);
				const k = data.itemsList.filter(
					(n: any) => n?.getUserKyc?.userId?._id !== userId
				);
				setData({
					...data,
					itemsList: k,
				});
				setRefresh(Math.random());
			} else {
				message.error(res?.message);
			}
		} catch (e: any) {
			message.error('something went wrong');
		}
	};

	const getKycHistory = async () => {
		setKycHistory({ loading: true });
		try {
			const res: any = await baseuri.get('admin/kyc/rejected-kyc-records', {
				params: {
					userId: id,
				},
			});

			if (res.status === 200) {
				setKycHistory({ ...kycHistory, ...res.data.data, loading: false });
			} else {
				setKycHistory({ loading: false });
			}
		} catch (error) {
			setKycHistory({ loading: false });
		}
	};

	const getSingleKYC = async () => {
		setData({ loading: true });
		try {
			const res: any = await baseuri.get('admin/kyc/single-kyc-details', {
				params: {
					id,
				},
			});

			if (res.status === 200) {
				setData({
					...data,
					itemsList: [res.data.data],
					loading: false,
					...res.data.data,
				});
			} else {
				setData({ loading: false });
			}
		} catch (error) {
			setData({ loading: false });
		}
	};

	const hiddenNumbers = (kyc: string) => {
		const firstTwo = kyc.slice(0, 2);
		const lastTwo = kyc.slice(-2);
		const zeros = '0'.repeat(Math.max(0, kyc.length - 4));
		return firstTwo + zeros + lastTwo;
	};

	useEffect(() => {
		getKycHistory();
		getSingleKYC();
		dispatch(getUserProfileById(id));
	}, [refresh, id]);

	const columns = [
		{
			title: 'User',
			key: '_id',
			width: 150,
			render: (text: any) => (
				// eslint-disable-next-line no-underscore-dangle
				<TableProfile>
					<div className="avatarSection">
						{text?.getUserKyc?.profileUrl ? (
							<Avatar src={text?.getUserKyc?.userId?.profileUrl} />
						) : (
							<Avatar className="avatar">
								{' '}
								{text?.getUserKyc?.userId?.username?.charAt(0)}
							</Avatar>
						)}
						<Link
							title="View Profile"
							to={`/user-profile/${text?.getUserKyc.userId._id}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<p>
								<strong>@{text?.getUserKyc?.userId?.username}</strong>
							</p>
							<p>{text?.getUserKyc?.userId?.email}</p>
						</Link>
					</div>
					<br />
					<div>
						<p>
							FIRST NAME:{' '}
							<span>{text?.getUserKyc?.userId?.firstName || '---'}</span>
						</p>
						<p>
							MIDDLE NAME:{' '}
							<span>{text?.getUserKyc?.userId?.middleName || '---'}</span>
						</p>
						<p>
							LAST NAME:{' '}
							<span>{text?.getUserKyc?.userId?.lastName || '---'}</span>
						</p>
						<p>
							PHONE NO:{' '}
							<span>{text?.getUserKyc?.userId?.phoneNo || '---'}</span>
						</p>
						<br />
						<p>
							Referred by:{' '}
							<strong>{text?.getUserKyc?.userId?.refereeName || '---'}</strong>
						</p>
					</div>
				</TableProfile>
			),
		},
		{
			title: 'Level 1',
			key: '9024352',
			render: (text: any) => (
				<Level1Section>
					<p>
						FIRST NAME:{' '}
						<strong>{`${text?.getUserKyc?.firstName}` || '--'}</strong>
					</p>
					<p>
						MIDDLE NAME:{' '}
						<strong>{`${text?.getUserKyc?.middleName}` || '--'}</strong>
					</p>
					<p>
						LAST NAME:{' '}
						<strong>{`${text?.getUserKyc?.lastName}` || '--'}</strong>
					</p>
					<p>
						PHONE NUMBER:{' '}
						<strong>+{text?.getUserKyc?.phoneNumber || '--'}</strong>
					</p>
					<p>
						DATE OF BIRTH:{' '}
						<strong>{text?.getUserKyc?.dateOfBirth || '--'}</strong>
					</p>
					<p>
						Age:{' '}
						<strong>
							{Math.floor(
								moment().diff(
									moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'),
									'years'
								)
							) <= 18 ? (
								<FakeRef>
									<Tooltip title="User is too young" color="#a10909">
										{moment().diff(
											moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'),
											'years'
										)}
									</Tooltip>
								</FakeRef>
							) : (
								moment().diff(
									moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'),
									'years'
								)
							)}
						</strong>
					</p>
					<p>
						Gender:{' '}
						<strong>{genderEnum(text?.getUserKyc?.gender) || '--'}</strong>
					</p>
					<p>
						ADDRESS:{' '}
						<strong
							className={`${
								text?.getUserKyc?.residentAddress.length < 15 ? 'sus' : ''
							}`}
						>
							{' '}
							{text?.getUserKyc?.residentAddress || '--'}
						</strong>
					</p>
					<p>
						COUNTRY:{' '}
						<strong>
							{Country(text?.getUserKyc?.countryCode.toUpperCase()) || '--'}
						</strong>
					</p>
					<p>
						Device Id/Serial No.:{' '}
						<strong>
							{text?.getUserKyc?.deviceId ||
								text?.getUserKyc?.userId?.deviceSerialNumber}
						</strong>
					</p>
					<p>
						Date Create:{' '}
						<strong>
							{moment(text?.getUserKyc?.createdAt).format('lll') || '--'}
						</strong>
					</p>
					<p>
						Date Updated:{' '}
						<strong>
							{moment(text?.getUserKyc?.updatedAt).format('lll') || '--'}
						</strong>
					</p>
					<br />
					<br />
					{/* {text?.getUserKyc?.userId?.kycBVN && (
						<p>
							Kyc BVN: <strong> {text?.getUserKyc?.userId?.kycBVN}</strong>
						</p>
					)} */}

					<p className={data?.blacklistRecord?.blacklisted ? 'sus' : ''}>
						BlackListed User/Device:{' '}
						<strong>{data?.blacklistRecord?.blacklisted ? 'Yes' : 'No'}</strong>
					</p>
					{text?.getUserKyc?.deviceId && (
						<SusLink
							className={Number(data?.kycUsedDeviceId) > 1 ? ' sus' : ''}
						>
							<>
								KYCs with same device:{' '}
								<strong>{data?.kycUsedDeviceId || 0}</strong>
							</>
							{Number(data?.kycUsedDeviceId) > 1 && (
								<Tag
									style={{
										cursor: 'pointer',
									}}
									color="processing"
								>
									<Link
										to={`/kyc-suspects?deviceId=${
											text?.getUserKyc?.deviceId ||
											text?.getUserKyc?.userId?.deviceSerialNumber
										}`}
									>
										{' '}
										View
									</Link>
								</Tag>
							)}
						</SusLink>
					)}
					<SusLink
						className={Number(data?.duplicatephoneNumber) > 1 ? ' sus' : ''}
					>
						<>
							KYCs with same Phone Number:{' '}
							<strong>{data?.duplicatephoneNumber || 0}</strong>
						</>
						{Number(data?.duplicatephoneNumber) > 1 && (
							<Tag
								style={{
									cursor: 'pointer',
								}}
								color="warning"
							>
								<Link
									to={`/kyc-suspects?phoneNumber=${text?.getUserKyc?.phoneNumber}`}
								>
									{' '}
									View
								</Link>
							</Tag>
						)}
					</SusLink>
					<SusLink
						className={Number(data?.duplicateIdcardNumber) > 1 ? ' sus' : ''}
					>
						<>
							KYCs with same ID Number:{' '}
							<strong>{data?.duplicateIdcardNumber || 0}</strong>
						</>
						{Number(data?.duplicateIdcardNumber) > 1 && (
							<Tag
								style={{
									cursor: 'pointer',
								}}
								color="error"
							>
								<Link
									to={`/kyc-suspects?idcardNumber=${text?.getUserKyc?.idcardNumber}`}
								>
									{' '}
									View
								</Link>
							</Tag>
						)}
					</SusLink>
					<SusLink
						className={Number(data?.userRegisteredWithDevice) > 1 ? ' sus' : ''}
					>
						<>
							Users with same device:{' '}
							<strong>{data?.userRegisteredWithDevice || 0}</strong>
						</>
						{Number(data?.userRegisteredWithDevice) > 1 && (
							<Tag
								style={{
									cursor: 'pointer',
								}}
								color="error"
							>
								<Link
									to={`/kyc-suspects?deviceId=${
										text?.getUserKyc?.deviceId ||
										text?.getUserKyc?.userId?.deviceSerialNumber ||
										'N/A'
									}`}
								>
									{' '}
									View
								</Link>
							</Tag>
						)}
					</SusLink>
				</Level1Section>
			),
		},
		{
			title: 'Level 2',
			key: 309536,
			render: (text: any) => (
				<MainColumn>
					<p>
						Level 2 Status:{' '}
						<strong
							style={{
								color: `${statusColor(
									text?.getUserKyc?.userId?.kycLevelTwoStatus
								)}`,
							}}
						>
							{' '}
							{text?.getUserKyc?.userId?.kycLevelTwoStatus || 'N/A'}
						</strong>
					</p>
					<p>
						Last Updated by:{' '}
						<strong>
							{text?.getUserKyc?.userId?.KycLevelTwoApprovedBy?.email || 'N/A'}
						</strong>
					</p>
					<Levels>
						<p>
							<strong>ID Card</strong>
							<ImageComponent
								createdAt={text?.getUserKyc?.createdAt}
								secret={text?.getUserKyc?.idcardEncryptKey}
								url={`${text?.getUserKyc?.idcardUrl}`}
							/>
						</p>
						<p>
							<strong>Live Photo</strong>
							<ImageComponent
								createdAt={text?.getUserKyc?.createdAt}
								secret={text?.getUserKyc?.selfieEncryptKey}
								url={`${text?.getUserKyc.selfieUrl}`}
							/>
						</p>
					</Levels>
					<p>
						ID Type: <strong> {text?.getUserKyc?.idcardType || 'N/A'}</strong>
					</p>
					<p>
						ID NUMBER:{' '}
						<strong> {text?.getUserKyc?.idcardNumber || 'N/A'}</strong>
					</p>
					{/* <Divider /> */}

					<Levels>
						{text?.getUserKyc?.userId?.kycLevelTwoStatus === 'submitted' ||
						text?.getUserKyc?.userId?.kycLevelTwoStatus === 'rejected' ? (
							<Tag
								style={{ cursor: 'pointer' }}
								color="blue"
								onClick={() =>
									approve(
										text?.getUserKyc?.userId?._id,
										'admin/kyc/level-two-kyc'
									)
								}
							>
								Approve
							</Tag>
						) : (
							''
						)}
						{text?.getUserKyc?.userId?.kycLevelTwoStatus === 'submitted' ||
						text?.getUserKyc?.userId?.kycLevelTwoStatus === 'approved' ? (
							<RejectKYC
								text="Reject"
								url="admin/kyc/level-two-kyc"
								userId={text?.getUserKyc?.userId}
								data={data}
								setData={setData}
								setRefresh={setRefresh}
							/>
						) : (
							''
						)}
					</Levels>
					<br />
					<br />
					{text?.getUserKyc?.custodialAdminId && (
						<strong>Updated by Admin</strong>
					)}
				</MainColumn>
			),
		},
	];
	const columns2 = [
		{
			title: 'Level 1',
			key: 9024352,
			render: (text: any) => (
				<Level1Section>
					<p>
						FULL NAME:{' '}
						<strong>
							{`${text?.lastName}  ${text?.firstName}  ${text?.middleName}` ||
								'N/A'}
						</strong>
					</p>
					<p>
						PHONE NUMBER: <strong>+{text?.phoneNumber || 'N/A'}</strong>
					</p>
					<p>
						DATE OF BIRTH: <strong>{text?.dateOfBirth || 'N/A'}</strong>
					</p>
					<p>
						Age:{' '}
						<strong>
							{Math.floor(
								moment().diff(moment(text?.dateOfBirth, 'DD/MM/YYYY'), 'years')
							) <= 18 ? (
								<FakeRef>
									<Tooltip title="User is too young" color="#a10909">
										{moment().diff(
											moment(text?.dateOfBirth, 'DD/MM/YYYY'),
											'years'
										)}
									</Tooltip>
								</FakeRef>
							) : (
								moment().diff(moment(text?.dateOfBirth, 'DD/MM/YYYY'), 'years')
							)}
						</strong>
					</p>
					<p>
						Gender: <strong>{genderEnum(text?.gender) || 'N/A'}</strong>
					</p>
					<p>
						ADDRESS:{' '}
						<strong
							className={`${text?.residentAddress.length < 15 ? 'sus' : ''}`}
						>
							{text?.residentAddress || 'N/A'}
						</strong>
					</p>
					<p>
						COUNTRY:{' '}
						<strong>{Country(text?.countryCode.toUpperCase()) || 'N/A'}</strong>
					</p>
				</Level1Section>
			),
		},
		{
			title: 'Level 2',
			key: 309536,
			render: (text: any) => (
				<MainColumn>
					<p>
						Rejected by: <strong>{text?.rejectedBy?.email || 'N/A'}</strong>
					</p>
					<Levels>
						<p>
							<strong>ID Card</strong>
							<ImageComponent
								secret={text.idcardEncryptKey}
								url={`${text.idcardUrl}`}
								createdAt={text?.createdAt}
							/>
						</p>
						<p>
							<strong>Live Photo</strong>
							<ImageComponent
								secret={text.selfieEncryptKey}
								url={`${text.selfieUrl}`}
								createdAt={text?.createdAt}
							/>
						</p>
					</Levels>
					<p>
						ID Type: <strong> {text?.idcardType || 'N/A'}</strong>
					</p>
					<p>
						ID NUMBER: <strong> {text?.idcardNumber || 'N/A'}</strong>
					</p>
					{/* <Divider /> */}

					{/* <Levels>
						{text?.userId?.kycLevelTwoStatus === 'submitted' && (
							<Tag
								style={{ cursor: 'pointer' }}
								color="blue"
								onClick={() =>
									approve(text?.userId?._id, 'admin/kyc/update-levelTwo-kyc')
								}
							>
								Approve
							</Tag>
						)}
						{text?.userId?.kycLevelTwoStatus === 'submitted' ||
						text?.userId?.kycLevelTwoStatus === 'approved' ? (
							<RejectKYC
								text="Reject"
								url="admin/kyc/update-levelTwo-kyc"
								userId={text?.userId}
								data={data}
								setData={setData}
								setRefresh={setRefresh}
							/>
						) : (
							''
						)}
					</Levels> */}
				</MainColumn>
			),
		},
		{
			title: 'Rejection Message',
			key: 309536,
			render: (text: any) => (
				<MainColumn>
					<p>
						Rejection Time:
						<strong>{moment(text?.rejectionTime).format('lll')}</strong>
					</p>
					<p>
						<strong>Rejection Reason</strong>
						<div>{text?.levelTwoRejectionReason}</div>
					</p>
					<p>
						<strong>Rejection Message</strong>
						<div>{text?.levelTwoRejectionMessage}</div>
					</p>
				</MainColumn>
			),
		},
	];

	return (
		<div>
			<SearchSection>
				<div>
					Select gateway :{' '}
					<Select
						// mode="multiple"
						placeholder="Select GateWay"
						// value={newsletter?.maillist}
						onChange={(e: any) => setSelectedGateway(e)}
						defaultValue="https://cf-ipfs.com/ipfs/"
						// style={{ width: '100%' }}
					>
						{gateWays?.map((gateway: any) => (
							<Select.Option key={gateway.name} value={gateway.value}>
								{gateway.name}
							</Select.Option>
						))}
					</Select>
				</div>
				<NextKyc text="Next KYC" />
			</SearchSection>
			<br />
			<MyCard>
				<Table
					loading={data?.loading}
					columns={columns}
					dataSource={data.itemsList}
					pagination={false}
					showHeader={false}
				/>
			</MyCard>

			<MyCard style={{ marginTop: '8px' }}>
				<h2 style={{ marginBottom: '8px' }}>
					<strong>Kyc BVN Data</strong>
				</h2>
				{data?.getUserKyc?.userId?.kycBVNData ? (
					<div style={KYCDataCard}>
						<div>
							<p>
								<strong>ID Card</strong>
							</p>
							<ImageComponent
								createdAt=""
								secret=""
								url={`${data?.getUserKyc?.userId?.kycBVNData?.photo}`}
							/>
						</div>
						<div>
							<p>
								FirstName:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.firstName
										? data?.getUserKyc?.userId?.kycBVNData?.firstName
										: '--'}
								</strong>
							</p>
							<p>
								Middle Name:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.middleName
										? data?.getUserKyc?.userId?.kycBVNData?.middleName
										: '--'}
								</strong>
							</p>
							<p>
								Last Name:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.lastName
										? data?.getUserKyc?.userId?.kycBVNData?.lastName
										: '--'}
								</strong>
							</p>
							<p>
								Gender:{' '}
								<strong>
									{' '}
									{data?.getUserKyc?.userId?.kycBVNData?.gender
										? data?.getUserKyc?.userId?.kycBVNData?.gender
										: '--'}
								</strong>
							</p>
							<p>
								Birthday:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.birthday
										? data?.getUserKyc?.userId?.kycBVNData?.birthday
										: '--'}
								</strong>
							</p>
							<p>
								BVN:
								<strong>
									{' '}
									{data?.getUserKyc?.userId?.kycBVNData?.bvn
										? hiddenNumbers(data?.getUserKyc?.userId?.kycBVNData?.bvn)
										: '--'}
								</strong>
								{data?.getUserKyc?.userId?.kycBVN && (
									<div className="profile-badge-icon">
										<span className="material-symbols-outlined icon">
											check_small
										</span>
									</div>
								)}
							</p>
							<p>
								Phone Number:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.phoneNumber
										? data?.getUserKyc?.userId?.kycBVNData?.phoneNumber
										: '--'}
								</strong>
							</p>
							<p>
								Phone Number2:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.phoneNumber2
										? data?.getUserKyc?.userId?.kycBVNData?.phoneNumber2
										: '--'}
								</strong>
							</p>
						</div>
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>BVN data not available</div>
				)}
			</MyCard>

			{/* Sumsub data */}
			<MyCard style={{ marginTop: '8px' }}>
				<h2 style={{ marginBottom: '8px' }}>
					<strong>SUM SUB Data</strong>
				</h2>
				{data?.getUserKyc?.sumsubData?.country ? (
					<div>
						<p>
							Country:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.country
									? data?.getUserKyc?.sumsubData?.country
									: '--'}
							</strong>
						</p>
						<p>
							Dob:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.dob
									? data?.getUserKyc?.sumsubData?.dob
									: '--'}
							</strong>
						</p>
						<p>
							First Name:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.firstName
									? data?.getUserKyc?.sumsubData?.firstName
									: '--'}
							</strong>
						</p>
						<p>
							Last Name:{' '}
							<strong>
								{' '}
								{data?.getUserKyc?.sumsubData?.lastName
									? data?.getUserKyc?.sumsubData?.lastName
									: '--'}
							</strong>
						</p>

						<p style={{ marginTop: '12px', marginBottom: '3px' }}>
							<strong>ID Docs</strong>
						</p>
						<div className="sumsub-grid">
							{data?.getUserKyc?.sumsubData?.idDocs?.length > 0 &&
								data?.getUserKyc?.sumsubData?.idDocs?.map((idDoc: any) => (
									<div
										key={idDoc?.number}
										style={{ border: '1px solid #d4caca', padding: '4px 13px' }}
									>
										<p>
											Country:{' '}
											<strong>{idDoc?.country ? idDoc?.country : '--'}</strong>
										</p>
										<p>
											Dob: <strong>{idDoc?.dob ? idDoc?.dob : '--'}</strong>
										</p>
										<p>
											First Name:{' '}
											<strong>
												{idDoc?.firstName ? idDoc?.firstName : '--'}
											</strong>
										</p>
										<p>
											First Name En:{' '}
											<strong>
												{idDoc?.firstNameEn ? idDoc?.firstNameEn : '--'}
											</strong>
										</p>
										<p>
											Last Name:{' '}
											<strong>
												{idDoc?.lastName ? idDoc?.lastName : '--'}
											</strong>
										</p>
										<p>
											Last Name En:{' '}
											<strong>
												{idDoc?.lastNameEn ? idDoc?.lastNameEn : '--'}
											</strong>
										</p>
										<p>
											Id Doc Type:{' '}
											<strong>
												{idDoc?.idDocType ? idDoc?.idDocType : '--'}
											</strong>
										</p>
										<p>
											MrzLine1:{' '}
											<strong>
												{idDoc?.mrzLine1 ? idDoc?.mrzLine1 : '--'}
											</strong>
										</p>
										<p>
											MrzLine2:{' '}
											<strong>
												{idDoc?.mrzLine2 ? idDoc?.mrzLine2 : '--'}
											</strong>
										</p>
										<p>
											Number:{' '}
											<strong>{idDoc?.number ? idDoc?.number : '--'}</strong>
										</p>
										<p>
											Valid Until:{' '}
											<strong>
												{idDoc?.validUntil ? idDoc?.validUntil : '--'}
											</strong>
										</p>
										<p>
											Termless:{' '}
											<strong>{idDoc?.termless ? 'True' : 'False'}</strong>
										</p>
									</div>
								))}
						</div>
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>Sum Sub data not available</div>
				)}
			</MyCard>

			{/* Kycaid data */}
			<MyCard style={{ marginTop: '8px' }}>
				<div style={{ marginBottom: '8px' }}>
					<p>
						Liveness Checked:{' '}
						<strong>{user?.profile?.livenessChecked ? 'True' : 'False'}</strong>
					</p>
				</div>

				<div style={{ marginBottom: '8px' }}>
					<p>
						Sum Sub Token:{' '}
						<strong style={{ wordBreak: 'break-all' }}>
							{user?.profile?.sumSubToken
								? `${user?.profile?.sumSubToken.slice(
										0,
										8
								  )}....${user?.profile?.sumSubToken.slice(-8)}`
								: '--'}
						</strong>
					</p>
				</div>
				<div className="sumsub-grid">
					{/* Kycaid grid 1 */}
					<div style={{ border: '1px solid #d4caca', padding: '4px 13px' }}>
						<h2 style={{ marginBottom: '8px' }}>
							<strong>Kyc Aid Data</strong>
						</h2>

						{user?.profile?.kycAidData ? (
							<div>
								<p>
									KYC Aid Applicant Id:{' '}
									<strong>{user?.profile?.kycAidApplicantId ?? '--'}</strong>
								</p>
								<p>
									KYC Aid Form Id:{' '}
									<strong>{user?.profile?.kycAidData?.form_id ?? '--'}</strong>
								</p>

								<p>
									KYC Aid Form Url:{' '}
									<strong>{user?.profile?.kycAidData?.form_url ?? '--'}</strong>
								</p>
								<p>
									KYC Aid Form Token:{' '}
									<strong>
										{user?.profile?.kycAidData?.form_token ?? '--'}
									</strong>
								</p>
								<p>
									KYC Aid Verification Id:{' '}
									<strong>
										{user?.profile?.kycAidData?.verification_id ?? '--'}
									</strong>
								</p>
								<p>
									Verification Attempts Left:{' '}
									<strong>
										{user?.profile?.kycAidData?.verification_attempts_left ??
											'--'}
									</strong>
								</p>
							</div>
						) : (
							<div style={{ textAlign: 'center' }}>
								Sum Sub data not available
							</div>
						)}
					</div>
					{/* Kycaid grid 2 */}
					<div style={{ border: '1px solid #d4caca', padding: '4px 13px' }}>
						<div
							style={{
								marginBottom: '8px',
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<h2>
								<strong>Kyc Aid Verification Data</strong>
							</h2>
							<Link
								title="Verification Portal"
								to="https://app.kycaid.com/verification"
								target="_blank"
								rel="noopener noreferrer"
								// style={{ background: '#1890FF', color: 'white' }}
							>
								Verification Portal
							</Link>
						</div>
						{data?.getUserKyc?.kycAidVerificationData ? (
							<div>
								<div className="verification-item">
									<h3>
										<strong>Profile</strong>
									</h3>
									<div>
										<p>
											<span>Comment: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.profile
													?.comment
													? data?.getUserKyc?.kycAidVerificationData?.profile
															?.comment
													: '--'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Verified: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.profile
													?.verified
													? 'True'
													: 'False'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Decline reasons: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.profile
													?.decline_reasons?.length > 0
													? data?.getUserKyc?.kycAidVerificationData?.profile?.decline_reasons?.map(
															(reason: any) => (
																<span key={reason}>{reason}, </span>
															)
													  )
													: '--'}
											</span>
										</p>
									</div>
								</div>
								<div className="verification-item">
									<h3>
										<strong>Facial</strong>
									</h3>
									<div>
										<p>
											<span>Comment: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.facial
													?.comment
													? data?.getUserKyc?.kycAidVerificationData?.facial
															?.comment
													: '--'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Verified: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.facial
													?.verified
													? 'True'
													: 'False'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Decline reasons: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.facial?.decline_reasons?.map(
													(reason: any) => (
														<span key={reason}>{reason}, </span>
													)
												)}
											</span>
										</p>
									</div>
								</div>
								<div className="verification-item">
									<h3>
										<strong>Document</strong>
									</h3>
									<div>
										<p>
											<span>Comment: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.document
													?.comment
													? data?.getUserKyc?.kycAidVerificationData?.document
															?.comment
													: '--'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Verified: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.document
													?.verified
													? 'True'
													: 'False'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Decline reasons: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.document?.decline_reasons?.map(
													(reason: any) => (
														<span key={reason}>{reason}, </span>
													)
												)}
											</span>
										</p>
									</div>
								</div>
								<div className="verification-item">
									<h3>
										<strong>Database Screening</strong>
									</h3>
									<div>
										<p>
											<span>Comment: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData
													?.database_screening?.comment
													? data?.getUserKyc?.kycAidVerificationData
															?.database_screening?.comment
													: '--'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Verified: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData
													?.database_screening?.verified
													? 'True'
													: 'False'}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Decline reasons: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.database_screening?.decline_reasons?.map(
													(reason: any) => (
														<span>{reason}, </span>
													)
												)}
											</span>
										</p>
									</div>
									<div>
										<p>
											<span>Databases: </span>
											<span style={{ fontWeight: 'bold' }}>
												{data?.getUserKyc?.kycAidVerificationData?.database_screening?.databases?.map(
													(database: any) => (
														<div
															key={database?.name}
															style={{
																marginBottom: '4px',
																border: '1px solid',
																padding: '4px',
															}}
														>
															<p>Type: {database?.type} </p>
															<p>Name: {database?.name} </p>
															<p>Url: {database?.url} </p>
														</div>
													)
												)}
											</span>
										</p>
									</div>
								</div>
							</div>
						) : (
							<p style={{ textAlign: 'center' }}>
								KycAid verification data is not available
							</p>
						)}
					</div>
				</div>
			</MyCard>

			<Divider />

			<MyTableCard>
				<TableHeaderSection
					tableName="Rejected KYC History"
					currentPage={kycHistory?.paginator?.currentPage || 0}
					totalRecords={kycHistory?.paginator?.itemCount || 0}
				/>
				<MyTable
					locale={{
						emptyText: <MyEmptyTable />,
					}}
					loading={kycHistory?.loading || false}
					columns={columns2}
					dataSource={kycHistory.itemsList}
					pagination={false}
				/>
			</MyTableCard>
		</div>
	);
};

export default ManageKYC;
